import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconDatabase';
/** Renders an SVG icon. */
const SvgDatabase = ({ size, 'aria-hidden': ariaHidden, tone, UNSAFE_className, UNSAFE_style, ...rest }: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        d="M26 9c0-.151-.081-.425-.517-.799-.432-.371-1.115-.751-2.047-1.09C21.581 6.437 18.953 6 16 6s-5.581.437-7.437 1.111c-.931.34-1.614.719-2.046 1.09C6.08 8.575 6 8.85 6 9s.081.425.517.799c.432.371 1.115.75 2.046 1.09C10.42 11.563 13.048 12 16 12s5.581-.437 7.436-1.111c.932-.34 1.615-.719 2.047-1.09C25.92 9.425 26 9.15 26 9m2 0c0 .953-.535 1.732-1.213 2.315-.681.586-1.608 1.069-2.667 1.454C21.994 13.542 19.123 14 16 14s-5.994-.458-8.12-1.231c-1.059-.386-1.986-.868-2.667-1.454C4.535 10.733 4 9.953 4 9s.535-1.732 1.213-2.315c.681-.586 1.608-1.069 2.667-1.454C10.006 4.458 12.877 4 16 4s5.994.458 8.12 1.231c1.059.385 1.986.868 2.667 1.454C27.465 7.268 28 8.047 28 9"
      />
      <path
        fill="currentColor"
        d="M4 23.294V9a1 1 0 0 1 2 0v14.294c0 .069.04.294.469.642.42.343 1.103.704 2.072 1.03C10.473 25.619 13.157 26 16 26s5.527-.382 7.459-1.033c.969-.327 1.652-.688 2.072-1.03.43-.35.469-.575.469-.643V9a1 1 0 1 1 2 0v14.294c0 .914-.54 1.652-1.206 2.194-.675.549-1.602 1.006-2.696 1.374C21.904 27.602 18.99 28 16 28s-5.904-.398-8.098-1.138c-1.093-.368-2.021-.825-2.696-1.374C4.54 24.946 4 24.208 4 23.294"
      />
      <path
        fill="currentColor"
        d="M27 16a1 1 0 0 1 1 1c0 .916-.655 1.567-1.287 1.983-.672.443-1.59.808-2.672 1.103-2.173.593-5.065.914-8.041.914s-5.868-.321-8.041-.914c-1.081-.295-2-.66-2.672-1.103C4.655 18.567 4 17.916 4 17a1 1 0 0 1 1.998-.04c.013.028.085.152.39.352.423.28 1.116.576 2.097.844C10.438 18.69 13.142 19 16 19s5.562-.311 7.515-.844c.981-.267 1.674-.565 2.097-.843.303-.2.375-.324.389-.352A1 1 0 0 1 27 16"
      />
      <path fill="currentColor" d="M25 15a1 1 0 1 1-2 0 1 1 0 0 1 2 0m0 7a1 1 0 1 1-2 0 1 1 0 0 1 2 0" />
    </svg>
  );
};
SvgDatabase.displayName = displayName;
export default SvgDatabase;
